import React, {PropTypes} from 'react';
const EstablishmentCheckList=({
  establishment,
  required_301,
  has_expected_301
})=>{
  const checked = <img src={require('../../../images/box-checked.svg')} className="checked"/>;
  const unchecked = <img src={require('../../../images/box-unchecked.svg')} className="unchecked"/>;
  const transparent = <img src={require('../../../images/box-transparent.svg')} className="unchecked"/>;
  let status = establishment.submission_status;
  let combined_status = establishment.combined_submission_status;
  return(
    <div className="estab-checklist border-container">
      <div className="estab-checklist-content">
        <label> Data Submission Progress</label>
        <div>
          {status>0? checked : unchecked}
          1. Create an Establishment
        </div>
        <div>
          {status>1? checked : unchecked}
          2. Add 300A Summary Data
        </div>
        {required_301 === 1 ? (
        <div>
          <div>
            {(combined_status === 1 || has_expected_301) ? checked : unchecked}
            3. Add 300/301 Case Data
          </div>
          <div>
            {combined_status === 1 ? checked : unchecked}
            4. Submit Data to OSHA
          </div>
          <div>
           {transparent}
           5. Review Confirmation Email
          </div>
        </div>
        ) : (
        <div>
          <div>
            {combined_status === 1 ? checked : unchecked}
            3. Submit Data to OSHA
          </div>
          <div>
            {transparent}
            4. Review Confirmation Email
          </div>
        </div>
        )}

      </div>
    </div>
  );
};

EstablishmentCheckList.propTypes = {
  establishment: PropTypes.object.isRequired,
  required_301: PropTypes.bool.isRequired,
  has_expected_301: PropTypes.bool.isRequired,
};
export default EstablishmentCheckList;



/** WEBPACK FOOTER **
 ** ./src/components/establishment/singleEstablishment/EstablishmentCheckList.js
 **/